<template>
  <div class="no-results">
    <figure class="image"><img src="/img/noresult.png" alt="" /></figure>
    <span class="title">No Result Found</span>
    <div class="text" v-html="text"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: String
  }
};
</script>

<style scoped>
.no-results {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  grid-template-rows: repeat(3, auto);
  justify-items: center;
}
.title {
  text-align: center;
  font-size: 1.5em;
  font-weight: 600;
}
.text {
  text-align: center;
}
@media (max-width: 600px) {
  .no-results {
    grid-template-columns: 320px;
    justify-items: center;
  }
  .image {
    margin: 0;
    max-width: 300px;
  }
  .image > img {
    margin: 0;
    max-width: 300px;
  }
}
</style>
